(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("i18n/kk", [], factory);
	else if(typeof exports === 'object')
		exports["i18n/kk"] = factory();
	else
		root["i18n/kk"] = factory();
})(window, function() {
return 